import { motion } from "framer-motion";
import { CHALLENGES, PATH_STEPS, REFORGE_FLOW } from "@/data/forge";

export default function PathChallenges() {
  return (
    <section data-testid="path-section" className="py-12 md:py-16">
      <div className="mx-auto w-[min(1180px,calc(100%-32px))]">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <div className="eyebrow-label mb-4">Your training</div>
            <h2 className="headline text-3xl sm:text-4xl lg:text-5xl mb-6">
              <span className="text-white">Your Forge</span>
              <span className="text-ember"> Your Path</span>
            </h2>

            <div className="space-y-3 mb-9">
              {PATH_STEPS.map((step, i) => (
                <motion.div
                  key={step.n}
                  data-testid={`path-step-${step.n}`}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  className="group flex items-center gap-4"
                >
                  <span className="w-8 h-8 shrink-0 rounded-full border border-forge/70 grid place-items-center display text-[11px] text-forge group-hover:bg-forge group-hover:text-ink transition-colors">
                    {step.n}
                  </span>
                  <span className="headline text-xl">{step.title}</span>
                  <span className="text-[11px] text-white/35 tracking-wide">{step.sub}</span>
                </motion.div>
              ))}
            </div>

            <div className="eyebrow-label mb-3">Forge · Reforge</div>
            <div className="flex flex-wrap items-center gap-2">
              {REFORGE_FLOW.map((step, i) => (
                <span key={step} className="flex items-center gap-2" data-testid={`reforge-step-${i}`}>
                  <span className="display text-[11px] tracking-[0.16em] px-3.5 py-2 rounded-xl border border-white/12 bg-[#121214] text-white/75 hover:border-ember hover:text-ember transition-colors">
                    {step}
                  </span>
                  {i < REFORGE_FLOW.length - 1 && <span className="text-forge/70 text-sm">→</span>}
                </span>
              ))}
            </div>
          </div>

          <div>
            <div className="eyebrow-label mb-4">Build a path</div>
            <h2 className="headline text-3xl sm:text-4xl lg:text-5xl mb-6">
              <span className="text-white">Not just a workout</span>
              <br />
              <span className="text-forge">A Forge</span>
            </h2>
            <div className="space-y-2.5">
              {CHALLENGES.map((c, i) => (
                <motion.article
                  key={c.days}
                  data-testid={`challenge-${c.days}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="group relative overflow-hidden rounded-2xl bg-[#0b0b0c] border border-white/10 px-5 py-4 flex items-center gap-5 hover:border-forge/45 transition-colors"
                >
                  <span className="absolute left-0 top-0 bottom-0 w-[2px] ember-line" />
                  <span className="headline text-3xl w-16 shrink-0">{c.days}</span>
                  <span className="min-w-0">
                    <span className="headline text-lg block group-hover:text-ember transition-colors">{c.title}</span>
                    <span className="text-[12px] text-white/45 block leading-snug">{c.copy}</span>
                  </span>
                </motion.article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
